import { DEVICE_STATE_KEY, DeviceState } from './device-reducer';

export enum DEVICE_ACTION_TYPE {
  SET_DEVICE_STATE = 'SET_DEVICE_STATE',
  CALL_DEVICE_LIST_TNC = 'CALL_DEVICE_LIST_TNC',
}

export type SetDeviceStateAction<KeyName extends keyof DeviceState> = {
  type: DEVICE_ACTION_TYPE.SET_DEVICE_STATE;
  payload: { key: KeyName, value: DeviceState[KeyName] };
};


export type DeviceActions = SetDeviceStateAction<DEVICE_STATE_KEY>;
